import { useState, useEffect } from "react";

const useGetSiteImage = (imageName) => {
  const [imageURL, setImageURL] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getImage = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + `/api/itemConfigs/getSiteImage/${imageName}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch image");
        }

        const data = await response.json();
        setImageURL(data);
      } catch (error) {
        console.error('Failed to fetch image:', error);
        setError(error.message);
      }
    };

    if (imageName) {
      getImage();
    }
  }, [imageName]);

  return { imageURL, error };
};

export default useGetSiteImage;